import { useState, useEffect } from 'react';

/**
 * Live-updating clock that ticks every `intervalMs` ms.
 * Returns the current Date instance.
 */
export function useClock(intervalMs = 1000) {
  const [time, setTime] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setTime(new Date()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return time;
}

/**
 * Formatted clock string for the given IANA-like offset in minutes.
 * Defaults to IST (+330 = UTC+5:30). Format: HH:MM:SS
 */
export function useOffsetClock(offsetMinutes = 330) {
  const now = useClock();
  const ms = now.getTime() + offsetMinutes * 60 * 1000;
  return new Date(ms).toISOString().split('T')[1].split('.')[0];
}

/**
 * Reports whether the window has been scrolled past a given threshold (px).
 */
export function useScrolled(threshold = 20) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > threshold);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [threshold]);
  return scrolled;
}
